import TruststoreCertificateDetail from './TruststoreCertificateDetail';

export default TruststoreCertificateDetail;
